import { Swiper, SwiperSlide } from "swiper/react";
import { ExploreCard } from "components";
import { useGetPOIListQuery } from "../redux/services/cityServices";

export default function Explore({ className }) {
  const poiResponse = useGetPOIListQuery();

  if (!poiResponse?.data?.cpoilist?.length) {
    return;
  }

  return (
    <div className={`w-full ${className}`}>
      <div className="text-base md:text-[32px] lg:leading-8 font-semibold text-black mb-3">
        Explore with Maraliner
      </div>
      <div className="text-base text-[#112211] mb-10 hidden lg:block">
        Lorem ipsum is a placeholder text commonly used to demonstrate.
      </div>
      <div className="w-full flex">
        <Swiper
          slidesPerView={1.5}
          spaceBetween={18}
          style={{ width: "100%" }}
          breakpoints={{
            380: {
              slidesPerView: 1.5,
            },
            420: {
              slidesPerView: 2.2,
            },
            980: {
              slidesPerView: 3,
            },
          }}
        >
          {poiResponse?.data?.cpoilist.map((item, index) => (
            <SwiperSlide key={index}>
              <ExploreCard key={index} data={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
